export const filesize = {
    mp4: 20480000,
    other: 3072000
}
export const website_url='https://www.sairmall.com/';
export const SAILMALL_BASE_URL = 'https://www.sairmall.com/';